const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Compatibility shim: newer Dawn assets expect window.StandardEvents
   (provided by a storefront module this layout does not load). */
window.StandardEvents = window.StandardEvents || {
  createViewEventElement: function (Base) {
    Base = Base || HTMLElement;
    return class extends Base {};
  },
  PageViewEvent: function () {},
  ProductViewEvent: function () {},
  CollectionViewEvent: function () {},
  SearchViewEvent: function () {},
  CartViewEvent: function () {},
};
